export default __webpack_public_path__ + "static/media/profile.0e232d2a.png";